import Vue from 'vue';
import App from './App.vue';

//vue-cookie
import VueCookie from 'vue-cookie';

//饿了么组件
import ElementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//vuex
import store from '@/store';

//路由
import VueRouter from 'vue-router';
import router from '@/router';

//vue-cookie
Vue.use(VueCookie);

//路由
Vue.use(VueRouter);

//饿了么组件
Vue.use(ElementUi);

//消除生产提示警告
Vue.config.productionTip = false;
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
